export const getBaseUrl = (path: string) => {
  if (path.startsWith("https://")) return path;
  const baseUrl = process.env.REACT_APP_API_Base;
  return baseUrl !== '/'? process.env.REACT_APP_API_Base + path: window?.location?.origin + path;
}